<template>
  <div>
    <WsButton001
      v-for="(item, itemIndex) in items"
      :key="itemIndex"
      :flat-button="item.flatButton"
      :out-line="item.outLine"
      :leading-icon="item.leadingIcon"
      :white="item.white"
      :red="item.red"
      class="mt-5"
      @click="$emit('alertPopupOpen')"
    >{{item.title}}</WsButton001>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          title: "複製",
          flatButton: true,
          outLine: true,
          leadingIcon: "icon-copy",
        },
        {
          title: "複製",
          outLine: true,
          leadingIcon: "icon-copy",
        },
        {
          title: "複製",
          leadingIcon: "icon-copy",
          white: true,
        },
        {
          title: "更新題目",
          leadingIcon: "icon-refresh",
        },
        {
          title: "編輯",
          leadingIcon: "icon-edit",
        },
        {
          title: "刪除",
          leadingIcon: "icon-delete",
          red: true
        },
      ]
    }
  },
}
</script>